import { services } from "../../../constants/services";
import { IParams, ResponseQ } from "../../../common/dtos/paginate.dto";
import { getByQuery } from "../../../utils/api";

export const GetLogsEntitiesWithPaginationService = async (params: any) => {
  const response = await getByQuery<ResponseQ<any>>(`${services.logBooking}/getLogEntities`, params);
  return response;
};